<template>
    <div v-if="Object.keys(topicsPerformance).length > 0" class="performance-card">
        <div class="performance-header">
            <div>
                <h3>Performance by Topic</h3>
                <p class="performance-subtitle">
                    {{
                        viewMode === 'quick'
                            ? 'Areas for Improvement - showing your 5 weakest topics (3+ attempts)'
                            : `Showing all ${Object.keys(topicsPerformance).length} topics`
                    }}
                </p>
            </div>
            <button
                @click="$emit('toggle-view')"
                class="view-toggle-btn"
                :disabled="!isPremium && viewMode === 'advanced'"
            >
                {{ viewMode === 'quick' ? 'Advanced View' : 'Quick View' }}
            </button>
        </div>

        <!-- Quick View -->
        <PerformanceQuickView
            v-if="viewMode === 'quick'"
            :topics-performance="topicsPerformance"
        />

        <!-- Advanced View -->
        <PerformanceAdvancedView
            v-else
            :filtered-topics="filteredTopics"
            :selected-module="selectedModule"
            :sort-by="sortBy"
            :sort-order="sortOrder"
            :search-query="searchQuery"
            @update:selectedModule="$emit('update:selectedModule', $event)"
            @update:sortBy="$emit('update:sortBy', $event)"
            @update:sortOrder="$emit('update:sortOrder', $event)"
            @update:searchQuery="$emit('update:searchQuery', $event)"
            @sort="$emit('sort', $event)"
        />
    </div>
</template>

<script>
import PerformanceQuickView from './PerformanceQuickView.vue';
import PerformanceAdvancedView from './PerformanceAdvancedView.vue';

export default {
    name: 'TopicPerformance',
    components: {
        PerformanceQuickView,
        PerformanceAdvancedView
    },
    props: {
        topicsPerformance: {
            type: Object,
            required: true
        },
        viewMode: {
            type: String,
            required: true
        },
        isPremium: {
            type: Boolean,
            required: true
        },
        filteredTopics: {
            type: Object,
            default: () => ({})
        },
        selectedModule: {
            type: String,
            default: 'all'
        },
        sortBy: {
            type: String,
            default: 'accuracy'
        },
        sortOrder: {
            type: String,
            default: 'asc'
        },
        searchQuery: {
            type: String,
            default: ''
        }
    },
    emits: ['toggle-view', 'update:selectedModule', 'update:sortBy', 'update:sortOrder', 'update:searchQuery', 'sort']
};
</script>

<style scoped>
.performance-card {
    background: var(--bg-secondary);
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: border-color 0.3s;
}

.performance-card:hover {
    border-color: var(--accent);
}

.performance-card h3 {
    margin: 0 0 20px 0;
    color: var(--text-secondary);
    font-size: 24px;
    letter-spacing: 2px;
}

.performance-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
}

.performance-subtitle {
    color: var(--text-primary);
    opacity: 0.7;
    font-size: 14px;
    margin-top: 5px;
}

.view-toggle-btn {
    padding: 10px 20px;
    background: var(--bg-secondary);
    color: var(--text-secondary);
    border: 2px solid rgba(var(--accent-rgb), 0.4);
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s;
    white-space: nowrap;
}

.view-toggle-btn:hover:not(:disabled) {
    background: var(--accent);
    transform: translateY(-2px);
    color: var(--bg-primary);
}

.view-toggle-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>